export default __webpack_public_path__ + "static/media/33.5fa7a87d.PNG";